// import React from 'react'
import img1 from './3.jpg';
import img2 from './1.jpeg';
import img3 from './2.jpeg';



const  arr  = [img1,img2,img3];

export default arr;